import { useState } from "react"
import type { NamedId } from "../../interface/publications"
import { namedOptionKey } from "../../services/adv/catalogs"
import { ResourceSelect } from "../common/resourceSelect"

/** ADV filters/types are unpaged catalogs. Search only the loaded catalog locally. */
export function CatalogSelect({
  label,
  value,
  options,
  onChange,
  isFetching = false,
  disabled,
}: {
  label: string
  value: NamedId | null
  options: readonly NamedId[]
  onChange: (value: NamedId | null) => void
  isFetching?: boolean
  disabled?: boolean
}) {
  const [search, setSearch] = useState("")
  return (
    <ResourceSelect
      size="small"
      label={label}
      value={value}
      options={options.filter(({ name }) =>
        name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
      )}
      getOptionKey={namedOptionKey}
      getOptionLabel={({ name }) => name}
      onChange={(selected) => {
        setSearch("")
        onChange(selected)
      }}
      onSearch={setSearch}
      onOpen={() => setSearch("")}
      onLoadMore={() => {}}
      hasMore={false}
      isFetching={isFetching}
      disabled={disabled}
    />
  )
}
